import { render, staticRenderFns } from "./OnboardingDecoration.vue?vue&type=template&id=1b1fbcbf&scoped=true"
import script from "./OnboardingDecoration.vue?vue&type=script&lang=ts"
export * from "./OnboardingDecoration.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingDecoration.vue?vue&type=style&index=0&id=1b1fbcbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1fbcbf",
  null
  
)

export default component.exports